<template>
  <div class="bucketUseInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      每桶產出
    </li>
    <b-table
      :items="bucketUseInformationItem"
      :fields="bucketUseInformationFields"
      sticky-header="186px"
      :no-border-collapse="noBorderCollapse"
      class="text-center bucketUseInformation-table-detail"
      ><template #cell(screwWeight)="data">{{
        data.value.toLocaleString("en-US")
      }}</template></b-table
    >
    <!-- <p class="text-right">
      桶數總重:
      <span>{{ bucketUseInformationTotalWeight }}(KG)</span>
    </p> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "bucketUseInformation",
  data() {
    return {
      noBorderCollapse: true,
    };
  },
  computed: {
    ...mapGetters({
      bucketUseInformationFields:
        "bucketUseInformation/get_bucketUseInformationFields",
      bucketUseInformationItem:
        "bucketUseInformation/get_bucketUseInformationItem",
      // bucketUseInformationTotalWeight:
      //   "bucketUseInformation/get_bucketUseInformationTotalWeight",
    }),
  },
};
</script>

<style lang="scss">
.bucketUseInformation-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.bucketUseInformation-table-detail thead th {
  border-top: 1px solid;
}
.bucketUseInformation-table-detail th,
.bucketUseInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.bucketUseInformation-table-detail td {
  font-size: 1rem;
}
.bucketUseInformation-table-detail th:first-child,
.bucketUseInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.bucketUseInformation-table-detail {
  margin-bottom: 0px;
}
.bucketUseInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.bucketUseInformation-table-detail tr td {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/bucketUseInformation.vue